import BaseService from "./BaseService";
import AppConfiguration from "dataProvider/config";
import qs from "qs";

export default class DvrService extends BaseService {

    constructor() {
        super(AppConfiguration.apiBaseDvr, "");
    }

    async checkSn(params) {
        const path = `/camera/check`;
        const configs = this.getConfigs({
            params,

        })
        return await this.doGet(path, configs)
    }
    async checkPort(data) {
        const path = `/camera/login`;
        const configs = this.getConfigs({
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
        return await this.doPost(path, qs.stringify(data), configs);

    }
}